var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.259V6.741a1 1 0 0 1 1.504-.864l9.015 5.26a1 1 0 0 1 0 1.727l-9.015 5.259A1 1 0 0 1 7 17.259Z",
    fill: "currentColor"
  })));
};

export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNNyAxNy4yNTlWNi43NDEwNEM3IDUuOTY5MjUgNy44MzcyMSA1LjQ4ODM3IDguNTAzODcgNS44NzcyNkwxNy41MTkyIDExLjEzNjJDMTguMTgwNyAxMS41MjIxIDE4LjE4MDcgMTIuNDc3OSAxNy41MTkyIDEyLjg2MzhMOC41MDM4NyAxOC4xMjI3QzcuODM3MjEgMTguNTExNiA3IDE4LjAzMDggNyAxNy4yNTlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";